import React from 'react';
import { useSelector } from 'react-redux';
import { gql } from 'urql';

import { client } from '@wetransfer/transfer/_graphql';
import { State } from '@wetransfer/transfer/store/types';

const CurrentUserTeamsQuery = gql`
  query {
    currentUser {
      teams {
        id
        name
        logoUrl
        defaultName
        creatorId
        stripeCustomerId
        members {
          role
          user {
            email
            auth0UserId
            givenName
            familyName
            profilePicture {
              id
              sourceUrl
              imageUrl
              thumbnailUrl
            }
          }
        }
      }
    }
  }
`;

export interface Team {
  id: string;
  name: string;
  defaultName: boolean;
  logoUrl: string | null; // TO DO: remove null
  creatorId: string;
  members: Member[];
  channel: {
    name: string;
  };
  stripeCustomerId: string | null;
}

export interface Member {
  role: 'admin' | 'member';
  user: {
    email: string;
    auth0UserId: string;
    givenName: string;
    familyName: string;
    profilePicture: {
      id: string;
      sourceUrl: string;
      imageUrl: string;
      thumbnailUrl: string;
    };
  };
}

export interface CurrentUserTeamsQueryResponse {
  teams: Team[];
}

export function useCurrentUserTeamsQuery(): {
  data: CurrentUserTeamsQueryResponse;
  fetching: boolean;
} {
  const [fetching, setFetch] = React.useState(true);
  const [data, setData] = React.useState(null);
  const { auth } = useSelector((state: State) => ({ auth: state.auth }));
  // avoid using useQuery here due to unexpected behaviour with canceled requests
  React.useEffect(() => {
    let isLoggedIn = auth?.isLoggedIn;

    if (isLoggedIn) {
      client
        .query(CurrentUserTeamsQuery)
        .toPromise()
        .then(({ data }) => {
          if (isLoggedIn) {
            setData({ teams: data.currentUser.teams });
          }
        })
        .finally(() => {
          if (isLoggedIn) {
            setFetch(false);
          }
        });
    }

    return () => {
      // prevent state update after unmount
      isLoggedIn = false;
    };
  }, [auth?.isLoggedIn, setFetch]);

  return { data, fetching };
}
